import { isNull } from 'lodash';
import APIEndpoints from '../utils/apiEndpoints';
import AbstractService from './abstractService';

// Singleton instance
let instance = null;

const _SERVICE_UNAVAILABLE_ = new Error({ message : 'Service Unavailable' });

export default class NoteService extends AbstractService {
	static setup(baseURL, options) {
		instance = new NoteService(baseURL, options);
	}

	static getInstance() {
		return instance;
	}

	constructor(baseURL, options) {
		super(baseURL, options);
		this.endpoint = APIEndpoints.notes;
	}

	static getAll(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getAll(...params);
	}

	static delete(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._delete(...params);
	}

	static uploadNoteImage(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._uploadNoteImage(...params);
	}

	static addNote(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._addNote(...params);
	}

	_getAll(queryParams) {
		return this.get({
			endpoint : this.endpoint,
			queryParams,
		});
	}

	_delete({ id, queryParams, data }) {
		return this.del({
			endpoint : `${this.endpoint}/${id}`,
			queryParams,
			data,
		});
	}

	_uploadNoteImage({ fileData, queryParams }) {
		const data = new FormData();
		data.append('file', fileData);

		return this.post({
			endpoint : `${this.endpoint}/picture`,
			queryParams,
			data,
		});
	}

	_addNote({ queryParams, data }) {
		return this.post({
			endpoint : this.endpoint,
			queryParams,
			data,
		});
	}
}
